export class DescontoPromocional {
  constructor(public id: number, public empresa: number,
              public descricao: string, public desconto: number, public cumulativa: boolean = false
  , public produtosAdicionados: any[] = []) {
  }
}
